import { Component, computed, Signal } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { AccessService } from '../../services/access.service';
import { DowntimeService } from '../../services/downtime.service';

@Component({
  selector: 'app-header-downtime',
  imports: [TooltipModule],
  templateUrl: './header-downtime.component.html',
  styles: ``
})
export class HeaderDowntimeComponent {

  isActive: Signal<boolean>;
  message: Signal<string>;

  constructor(private downtimeService: DowntimeService, private access: AccessService) {
    this.message = computed(() => this.downtimeService.downtime().downtimeMessage);
    this.isActive = computed(() => this.access.isAdministrator() && this.downtimeService.downtime().isDown);
  }
}
